import { printProfileIdFormat } from "@redotech/redo-fulfillment-id";
import * as z from "zod";

export const deletePrintProfile = {
  name: "deletePrintProfile" as const,
  input: z.object({ profileId: printProfileIdFormat.schema }),
  output: z.object({}),
};
